import { CrossIcon, SearchIcon } from '@mentimeter/ragnar-visuals';
import React from 'react';
import { TextInput } from '@mentimeter/ragnar-ui/input/text-input';

interface SearchProps {
  value: string;
  onSearch: (searchString: string) => void;
  onClear: () => void;
}

export function Search({ value, onSearch, onClear }: SearchProps) {
  return (
    <TextInput
      inputSize="compact"
      autoFocus
      width="100%"
      iconLeading={<SearchIcon />}
      iconTrailing={<CrossIcon />}
      iconTrailingAction={onClear}
      autoComplete="off"
      placeholder="Type to search"
      value={value}
      onChange={(e) => onSearch(e.target.value)}
    />
  );
}
